/* eslint-disable sonarjs/cognitive-complexity */
import { Box, Typography } from '@astro-ui/components'
import theme from '@astro-ui/theme'
import { useMemo } from 'react'
import { shallowEqual, useAppSelector } from 'store'

type InfoRowPropsType = {
  label: string
  value: React.ReactNode
  labelColor?: string
}

const InfoRow = ({ label, value, labelColor = '#646464' }: InfoRowPropsType) => (
  <Box display="flex" justifyContent="space-between" gap="32px">
    <Typography variant="body-small" whiteSpace="nowrap" color={labelColor}>
      {label}
    </Typography>
    <Typography
      variant={value ? 'headline-small' : 'body-small'}
      color={value ? theme.palette.textColor.primaryDark : labelColor}
      textAlign="right"
    >
      {value || 'Belum ada'}
    </Typography>
  </Box>
)

const RightPanel = () => {
  const data = useAppSelector((state) => state.outboundSODetail.data, shallowEqual)

  const information = useMemo(() => {
    const info = {
      checkerBy: '',
      pickerBy: '',
      putawayBy: '',
      loaderBy: '',
    }

    if (!data?.supplyOrderActivities) return info

    const getListName = (
      list: {
        name: string
        activity: string
        supplyOrderItemId: number | null
        status: string
        startAt: string
        endAt: string | null
        duration: string
      }[],
    ) =>
      list
        .reduce((acc: string[], { name }) => {
          if (!acc.includes(name)) acc.push(name)
          return acc
        }, [])
        .join(', ')

    data?.supplyOrderActivities?.forEach((item) => {
      const { checking, picking, putaway, loading } = item.activityLogList || {}

      if (checking?.length) {
        const names = getListName(checking)
        info.checkerBy = info.checkerBy ? `${info.checkerBy}, ${names}` : names
      }

      if (picking?.length) {
        const names = getListName(picking)
        info.pickerBy = info.pickerBy ? `${info.pickerBy}, ${names}` : names
      }

      if (putaway?.length) {
        const names = getListName(putaway)
        info.putawayBy = info.putawayBy ? `${info.putawayBy}, ${names}` : names
      }

      if (loading?.length) {
        const names = getListName(loading)
        info.loaderBy = info.loaderBy ? `${info.loaderBy}, ${names}` : names
      }
    })

    return info
  }, [data])

  return (
    <Box display="flex" flexDirection="column" gap="24px">
      <Box
        width="100%"
        borderRadius="8px"
        border="1px solid"
        borderColor={theme.colors.border}
        backgroundColor={theme.colors.white}
        padding="24px"
      >
        <Box display="flex" flexDirection="column" gap="32px">
          <Typography variant="display-tiny">Rangkuman Produk</Typography>

          <Box display="flex" flexDirection="column" gap="16px">
            <InfoRow label="Total SKU" value={data?.supplyOrderProductSummary.totalSku} />
            <InfoRow label="Jumlah Kuantiti" value={data?.supplyOrderProductSummary.totalQty} />
            <InfoRow label="Net Weight" value={data?.supplyOrderProductSummary.netWeight} />
            <InfoRow label="Gross Weight" value={data?.supplyOrderProductSummary.grossWeight} />
            <InfoRow label="Volume Weight" value={data?.supplyOrderProductSummary.volumeWeight} />
            <InfoRow label="Volume" value={data?.supplyOrderProductSummary.volume} />
          </Box>
        </Box>
      </Box>

      <Box
        width="100%"
        borderRadius="8px"
        border="1px solid"
        borderColor={theme.colors.border}
        backgroundColor={theme.colors.white}
        padding="24px"
      >
        <Box display="flex" flexDirection="column" gap="32px">
          <Typography variant="display-tiny">Informasi Staff</Typography>

          <Box display="flex" flexDirection="column" gap="16px">
            <InfoRow label="Picker oleh" value={information.pickerBy} />
            <InfoRow label="Checker oleh" value={information.checkerBy} />
            <InfoRow label="Putaway oleh" value={information.putawayBy} />
            <InfoRow label="Loader oleh" value={information.loaderBy} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default RightPanel
